<template>
	<div id="chat">
		<!-- Icon -->
		<div class="icon" v-on:click="open()">
			<i class="material-icons">sms</i>
		</div>

		<!-- Chat box -->
		<div class="chat-wrapper" v-bind:class="{ active: toggle }">

			<!-- Header -->
			<div class="padding-tb-2x">
				<h3>BATTLE CHAT</h3>
				<div class="close" v-on:click="open()">
					<i class="material-icons">clear</i>
				</div>
			</div>

			<!-- Chat -->
			<ul class="list padding" v-chat-scroll>
				<li v-for="message in messages" :key="message.id" class="flex-column start-start padding-tb-2x">
					<span class="color-r"> 
						<span class="color-r-sm dark">{{ message.name }}</span>
					</span>
					<span class="content color-r dark padding-2x padding-tb-3x">{{ message.content }}</span>
					<span class="color-r-sm dark">{{ message.timestamp }}</span>
				</li>
			</ul>

			<!-- Chat -->
			<ChatInput :name="user.address || 'anonymous'"/>
		</div>
	</div>

</template>

<script>
	import moment from 'moment';
	import { mapGetters } from "vuex";
	import { db } from '../../util/firebase';
	import ChatInput from '../../components/chat/ChatInput.vue';

	let messages = [];

	export default {
		name: 'Chat',
		components: {
			ChatInput
		},
		computed: {
			...mapGetters({
                user: 'getUser'
            })
		},
		data() {
			return {
				toggle: false,
				messages: messages
			}
		},
		methods: {
			open() {
				this.toggle = !this.toggle;
			}
		},
		created() {
			const ref = db.collection('message').orderBy('timestamp');
			
			ref.onSnapshot(snapshot => {
				snapshot.docChanges.forEach(el => {
					if (el.type === 'added') {
						const doc = el.doc;
						const { name, content, timestamp } = doc.data();
						
						this.messages.push({
							id: doc.id,
							name: name,
							content: content,
							timestamp: moment(timestamp).format('lll')
						});
					}
				});
			});
		}
	}
</script>

<style lang="less" scoped>
	@import '../../assets/less/layout';

	@app_black: #3c3f44;
	@thumb: #2d2d2d;
	@color_1: #e692f8;

	@li_even: #394EBB;
	@li_odd: #D30077;	

	#chat {
		z-index: 1000;
		.close {
			padding: 10px;
			top: 0;
			right: 0;
			font-size: 28px;
			position: absolute;
		}

		.icon {
			right: 20px;
			bottom: 15px;
			width: 75px;
			height: 75px;
			display: flex;
			position: fixed;
			cursor: pointer;
			text-align: center;
			flex-direction: row;
			align-items: center;
			border-radius: 15px;
			background-size: 50%;	
			justify-content: center;
			border: 4px solid @app_black;
            background-color: white;
            
			i {
				color: @app_black;
				font-size: 35px;
			}
		}
	}
	.chat-wrapper {
		bottom: 5px;
		width: 500px;
		right: -550px;
		height: 500px;
		position: fixed;
		border-radius: 5px;
		background-color:white;
        border-radius: 0;
        border: 2px solid @app_black;        
		// box-shadow: 0px 0px 7px 0px rgba(0, 0, 0, 0.75);
		transition: all 600ms cubic-bezier(0.895, 0.03, 0.685, 0.22);
		h3 {
			font-size: 20px;
			padding-top: 5px;
			padding-bottom: 5px;
			text-align: center;
		}
		ul {
			margin: 0;
			max-width: 97.5%;
			min-height: 328px;
			max-height: 60%;
			overflow: auto;	
			li {
				text-align: left;
			}
			li:nth-child(odd) {
				.content {
					border-left: 2px solid @li_odd;
				}
			}
			li:nth-child(even) {
				.content {
					border-left: 2px solid @li_even;
				}
			}
			list-style: none;
		}
		.content {
			background-color: #e8e8e8;
	
		}
		&.active {
			right: 0;
		}
	}

	

	.list::-webkit-scrollbar {
		width: 3px;
	}
	.list::-webkit-scrollbar-thumb {
		background-color: @thumb;
	}
	.list::-webkit-scrollbar-track {
		background-color: lightgray;
	}

	.color-r {
		font-family: 'Michroma';
		color: @color_1;
		&.dark {
			color: @thumb;
		}
	}

	.color-r-sm {
		color: @color_1;
		font-size: 12px;
		&.dark {
			color: #757575;
		}
	}

	input {
		width: 97%;
		height: 50px;
		outline: none;
	}

	
</style>




// WEBPACK FOOTER //
// src/components/chat/Chat.vue